import { useMemo } from 'react';
import { useQuery } from '@apollo/client/react';
import * as R from 'ramda';

import { GET_SCHEMAS } from '@atom/graph/schema';
import { Schema } from '@atom/types/schema';

type UseMapSchemasResult = {
  schemas: Schema[];
  loading: boolean;
};

const useMapSchemas = (): UseMapSchemasResult => {
  const { data, loading } = useQuery(GET_SCHEMAS, {
    variables: { input: { rootSchemas: true } },
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
  });

  const schemas = useMemo(
    () =>
      (data?.schemas?.schemas ?? []).filter(
        (schema: Schema): boolean => !R.isNil(schema.locationType),
      ),
    [data],
  );

  return { schemas, loading };
};

export default useMapSchemas;
